import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const SECURITY_IMAGE_DIGESTS_QUERY_KEY = 'security-image-digests';

const getImageDigestsQueryKey = (tagId: string) =>
  [SECURITY_IMAGE_DIGESTS_QUERY_KEY, tagId] as const;

const getImageDigestsQueryOptions = (tagId: string) =>
  queryOptions({
    queryKey: getImageDigestsQueryKey(tagId),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getImageDigests({
        tagId,
      });
      return data.items || null;
    },
  });

export const useImageDigestsQuery = (tagId: string) => {
  const {
    isLoading,
    data: digests,
    error,
    refetch,
  } = useQuery(getImageDigestsQueryOptions(tagId));

  return { isLoading, digests: digests || undefined, error, refetch };
};
